<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="order-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5
              class="modal-title text-white text-bold"
            >
              Create New Order
            </h5>
          </div>
          <div class="modal-body bg-white">

            <div class="row">
              <div class="col-md-12">
                <label>Product</label>
                <div class="form-group">
                  <v-select
                    v-model="product"
                    :options="products"
                    label="label"
                    :placeholder="product ? null : 'Select a Product'"
                  />
                  <small v-if="errors.product" class="text-danger">Product is required</small>
                </div>
              </div>
            </div>
            <div class="row">

              <div class="col-md-6 relative">
                <label>Customer</label>
                <v-select
                  class="select-version"
                  :options="consultants"
                  label="label"
                  v-model="consultant_id"
                  :reduce="(consultant) => consultant.id"
                  @input="fetchClients"
                  placeholder="Select Customer"
                />
              </div>
              <div v-if="product && product.support_client_selection && consultant_id" class="col-md-6 relative">
                <label class="text-danger">This product requires a client (final customer):</label>
                <v-select
                  class="select-client"
                  :options="clients"
                  label="first_name"
                  v-model="client_id"
                  :reduce="(client) => client.id"
                  placeholder="Select Client"
                />
              </div>
            </div>
            <div class="row">

              <div v-if="product && product.support_version_selection" id="version-id-input" class="col-md-6 mt-20">
                <label>Version</label>
                <v-select
                  class="select-version"
                  :options="product.configurations.versions"
                  label="name"
                  v-model="configurations.version"
                  :reduce="(version) => version.id"
                  placeholder="Select Version"
                />
                <small v-if="errors['configurations.version']" class="text-danger"
                >Required Version</small
                >
              </div>

              <div v-if="product && product.support_fabric_selection" id="fabric-id-input" class="col-md-6 mt-20">
                <label>Fabric</label>
                <v-select
                  class="select-fabric"
                  :options="fabrics"
                  v-model="configurations.fabric_id"
                  label="production_name"
                  :reduce="(fabrics) => fabrics.id"
                  placeholder="Select Fabric"/>

                <small v-if="errors['configurations.fabric_id']" class="text-danger">Required Fabric</small>
              </div>

              <div v-if="product && product.support_contrast_fabric_selection" id="contrast-fabric-id-input"
                   class="col-md-6 mt-20">
                <label>Contrast Fabric</label>
                <v-select
                  class="select-fabric"
                  :options="fabrics"
                  v-model="configurations.contrast_fabric_id"
                  label="production_name"
                  :reduce="(fabrics) => fabrics.id"
                  placeholder="Select Fabric"/>

                <small v-if="errors['configurations.contrast_fabric_id']" class="text-danger">Required Contrast
                  Fabric</small>
              </div>

              <div v-if="product && product.support_standard_size_selection" id="cuff-type-id-input"
                   class="col-md-6 mt-20">
                <label>Size</label>
                <v-select
                  class="select-size"
                  :options="product.configurations.sizes"
                  v-model="configurations.size"
                  placeholder="Select Size"
                />
                <small v-if="errors['configurations.size']" class="text-danger"
                >Required Size</small
                >
              </div>

              <div v-if="product && product.support_length_selection" id="length-input" class="col-md-6 mt-20">
                <div class="form-group">
                  <label>Length</label>
                  <v-select
                    class="length"
                    :options="getProductLengths(product)"
                    v-model="configurations.length"
                    :reduce="(length) => length"
                    placeholder="Select a length"/>
                  <small v-if="errors['configurations.length']" class="text-danger">Required Length</small>
                </div>
              </div>

              <div class="col-md-6 mt-20">
                <div class="form-group" v-if="product">
                  <label>Quantity</label>
                  <input
                    type="number"
                    class="form-control"
                    name="quantity"
                    v-model="quantity"
                    placeholder="Quantity"/>

                  <small v-if="errors.quantity" class="text-danger">Required Quantity</small>
                </div>
              </div>

            </div>

            <div v-if="isProcessing" class="col-12 mt-20">
              <div class="alert alert-info text-center">
                <strong>The system is placing your order to the Consultant System, this may take a few seconds. Please wait.</strong>
              </div>
            </div>

            <div v-if="showSuccessMessage" class="col-12 mt-20">
              <div class="alert alert-success text-center">
                <strong>Product Orders created successfully on the Consultant System.</strong>
              </div>
            </div>


            <div class="col-12 mt-20">
              <button class="btn btn-primary btn-block" @click="createOrder"
                      :disabled="product === null || isProcessing">
                Create order
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product: null,
      consultant_id: null,
      consultant_name: null,
      client_id: null,
      client_name: null,
      searchConsultant: null,
      searchClient: null,
      consultants: [],
      clients: [],
      errors: {},
      fabrics: [],
      products: [],
      configurations: {
        fabric_id: null,
        contrast_fabric_id: null,
        size: null,
        version: null
      },
      quantity: 1,
      showConsultantDropdown: false,
      showClientDropdown: false,
      showSuccessMessage: false,
      isProcessing: false,
    };
  },

  mounted() {
    this.getCreateData();
    this.getConsultants();
    this.getFabrics();
  },

  methods: {

    async getCreateData() {
      let res = await axios.get("product_orders/get_create_data");
      this.products = res.data.data.products;
    },

    async getConsultants() {
      let res = await axios.get("/v2/account/consultant", {
        params: {
          search: this.searchConsultant
        }
      });
      this.consultants = res.data.data;
    },

    async fetchClients() {
      if (!this.consultant_id) {
        return;
      }
      let res = await axios.get(`/v2/account/client/${this.consultant_id}`, {
        params: {
          search: this.searchConsultant
        }
      });
      this.clients = res.data.data;
    },

    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fabrics = res.data.data.collection;
    },

    async createOrder() {
      try {

        this.errors = {};
        this.isProcessing = true

        const requestParams = {
          product_id: this.product ? this.product.id : null,
          consultant_id: this.consultant_id,
          client_id: this.client_id,
          quantity: this.quantity,
          configurations: this.configurations
        };

        let res = await axios.post("product_orders/create_order", requestParams);
        if (res) {
          this.showSuccessMessage = true
          this.isProcessing = false
          setTimeout(() => {
            this.resetForm();
            this.showSuccessMessage = false
            hide_modal("#order-modal");
            if (res.data.is_accessory_order) {
              toastr.success("The order was added in the Accessory Orders");
            } else {
              toastr.success("Product Orders created successfully");
            }

            // Reload the page to display the new order.
            window.location.href = '/product_order/overview/imported'

          }, 3000);
        }
      } catch (error) {
        this.errors = error.response.data.errors
        this.isProcessing = false
        this.showSuccessMessage = false
      }

      this.showConsultantDropdown = false
      this.showClientDropdown = false
    },

    resetForm() {
      this.product = null;
      this.consultant_id = null;
      this.client_id = null;
      this.errors = {};
      this.configurations = {
        fabric_id: null,
        contrast_fabric_id: null,
        length: null,
        size: null,
        version: null
      };
      this.quantity = 1;
      this.consultant_name = null;
      this.searchConsultant = null;
      this.clients = [];
    },

    getProductLengths(product) {
      let lengthRange = product.configurations.lengths;
      let productLengths = [];
      for (let i = parseInt(lengthRange.min); i <= parseInt(lengthRange.max); i++) {
        productLengths.push(i);
      }
      return productLengths;
    }

  },
}
</script>


<style scoped>
.search-box {
  width: 95%;
  max-height: 300px;
  background-color: #fff;
  box-shadow: 0.2px 0.2px .5px rgb(80, 78, 78, 0.447);
  border-radius: 10px;
  padding: 10px;
  z-index: 1000 !important;
  position: absolute;
  top: 60px;
  left: 0;
  margin: 0 10px;
  overflow: scroll;
}

.consultant-link {
  cursor: pointer;
}
</style>
